// export const BaseUrl = 'https://jsonplaceholder.typicode.com'
// export const BaseUrl = 'https://beterra.stigeit.com'
export const BaseUrl = 'https://beperum.stigeit.com'
// export const BaseUrl = 'http://localhost:8000'
// export const BaseUrl = 'http://192.168.18.11:8000'
// export const BaseUrl = 'http://192.168.100.7:8000'
// export const BaseUrl = 'http://192.168.43.60:8000'
